import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import { Toast } from 'mint-ui'
import { kidLists, currentKid } from '@/api/kid'
import { getSkillSingleByMember, getSkillSingleByMemberXtc } from '@/api/shop'

const u1 = require('./views/shopping/image/u14.png')
const u2 = require('./views/shopping/image/u16.png')
const u3 = require('./views/shopping/image/u22.png')
const u4 = require('./views/shopping/image/u26.png')

const u34 = require('./views/shopping/image/u34.png')

// const u1 = require('./views/shopping/image/u14.png')
// const u2 = require('./views/shopping/image/u16.png')
// const u3 = require('./views/shopping/image/u22.png')
// const u4 = require('./views/shopping/image/u26.png')

// const u34 = require('./views/shopping/image/u34.png')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isXTC: sessionStorage.isXTC ? sessionStorage.isXTC : 0,
    kidLoading: true,
    xtcOpenId: sessionStorage.xtcOpenId ? JSON.parse(sessionStorage.xtcOpenId) : [],

    isManagePage: false,

    summerShow: false,
    firstIn: true,
    currentPage: 1,
    kidLists: [],
    currentKid: -1,
    skillStyle: {},
    currentIndex: 0,
    isSpring: true,
    exampleLists: {
      1: {
        urls: ['http://appfile.turingapi.com/watch/voice/201902/384_748_1548983517389.wav', 'http://appfile.turingapi.com/watch/voice/201811/1361_2739_1541306832363.wav', 'http://appfile.turingapi.com/watch/voice/201811/739_2028_1541306840553.wav'],
        question: ['燕', '支', '犹'],
        width: 0,
        transition: 0,
        tip: 'xxx新学会了3个汉字，快来听一听吧！',
        id: 1,
        skillDetail: [
          {
            title: '1.引导学习',
            con: '燕，燕子的燕，跟我读，燕，燕子',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E6%B1%89%E5%AD%97/%E5%9B%BE%E4%B8%80.png'
          },
          {
            title: '2.用户跟读',
            con: '跟读：燕，燕子',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E6%B1%89%E5%AD%97/%E5%9B%BE%E4%BA%8C.png'
          },
          {
            title: '3.判断对错，给予奖励',
            con: '根据学习结果，给与奖励',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E6%B1%89%E5%AD%97/%E5%9B%BE%E4%B8%89.png'
          },
          {
            type: 'end',
            title: '4.家长查看学习成就',
            con: '宝宝新学会了3个汉字，快来听听吧',
            img: ''
          }
        ]
      },
      2: {
        urls: ['http://appfile.turingapi.com/watch/voice/201902/3367_3366_1550314849213.wav', 'http://appfile.turingapi.com/watch/voice/201811/49_3409_1541065746462.wav', 'http://appfile.turingapi.com/watch/voice/201811/49_3419_1541066163619.wav'],
        question: ['chinese', 'running', 'poor'],
        width: 0,
        transition: 0,
        tip: 'xxx新学会了3个单词，快来听一听吧！',
        id: 2,
        skillDetail: [
          // {
          //   title: '1.引导学习',
          //   con: '中国的英文是Chinese，小朋友，跟我读Chinese',
          //   img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E5%8D%95%E8%AF%8D/%E5%9B%BE%E4%B8%80.png'
          // },
          // {
          //   title: '2.用户跟读',
          //   con: '跟读：Chinese',
          //   img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E5%8D%95%E8%AF%8D/%E5%9B%BE%E4%BA%8C.png'
          // },
          // {
          //   title: '3.判断对错，给予奖励',
          //   con: '根据发音情况判断，给与奖励',
          //   img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E5%8D%95%E8%AF%8D/%E5%9B%BE%E4%B8%89.png'
          // },
          // {
          //   type: 'end',
          //   title: '4.家长查看学习成就',
          //   con: '宝宝新学会了3个单词，快来听听吧',
          //   img: ''
          // }
          {
            title: '1.引导学习',
            con: '小红喜欢玩秋千，秋千的英文是swing，跟我读，swing',
            img: u1
          },
          {
            title: '2.用户跟读',
            con: '用户跟读：swing',
            img: u2
          },
          {
            title: '3.发音纠错',
            con: '系统根据用户的发音，给出得分，并标识出孩子发音中不准确的音标',
            img: u3
          },
          {
            title: '4.给与奖励',
            con: '系统给与奖励',
            img: u4
          },
          {
            // type: 'end',
            title: '5.家长查看学习成就',
            con: '',
            img: u34
          }
        ]
      },
      3: {
        urls: ['http://appfile.turingapi.com/watch/voice/201901/3860_3573_1546852021538.wav', 'http://appfile.turingapi.com/watch/voice/201901/3860_3573_1546852033738.wav', 'http://appfile.turingapi.com/watch/voice/201901/3860_3573_1546852047673.wav', 'http://appfile.turingapi.com/watch/voice/201901/3860_3573_1546852062385.wav', 'http://appfile.turingapi.com/watch/voice/201901/3860_3573_1546852199170.wav'],
        question: ['咏柳'],
        width: 0,
        transition: 0,
        tip: 'xxx跟读了古诗《咏柳》，朗读很标准，快来听听吧！',
        id: 3,
        skillDetail: [
          {
            title: '1.跟读模式',
            con: '用户逐句跟读，学完1~3遍后进入背诵',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E5%8F%A4%E8%AF%97/%E5%9B%BE%E4%B8%80.png'
          },
          {
            title: '2.背诵模式',
            con: '用户背诵全诗，背诵全对进入下一首',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E5%8F%A4%E8%AF%97/%E5%9B%BE%E4%BA%8C.png'
          },
          {
            title: '3.给予奖励',
            con: '根据学习结果，给与奖励',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E5%8F%A4%E8%AF%97/%E5%9B%BE%E4%B8%89.png'
          },
          {
            type: 'end',
            title: '4.家长查看学习成就',
            con: '宝宝背诵了古诗《咏柳》，快来听听吧',
            img: ''
          }
        ]
      },
      4: {
        urls: ['http://appfile.turingapi.com/watch/voice/201902/21513_4886_1549711150139.wav', 'http://appfile.turingapi.com/watch/voice/201902/21513_4886_1549711208641.wav'],
        question: ['-Can you play football?  -Yes，I can'],
        width: 0,
        transition: 0,
        tip: 'xxx正确跟读了1组对话，发音很棒哦，快来听听吧！',
        id: 4,
        skillDetail: [
          {
            title: '1.对话跟读',
            con: '练习句型 -Can you play football? -Yes，I can',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%8B%B1%E8%AF%AD%E5%AF%B9%E8%AF%9D/%E5%9B%BE%E4%B8%80.png'
          },
          {
            title: '2.场景实练',
            con: '用户听上一句，结合图片场景，用英语说出下一句',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%8B%B1%E8%AF%AD%E5%AF%B9%E8%AF%9D/%E5%9B%BE%E4%BA%8C.png'
          },
          {
            type: 'end',
            title: '3.纯正美式发音',
            con: '原汁原味的美式发音，让孩子口语更正宗！',
            img: ''
          }
        ]
      },
      5: {
        urls: ['http://appfile.turingapi.com/watch/voice/201902/32925_4789_1549007003676.wav', 'http://appfile.turingapi.com/watch/voice/201902/32925_4789_1549007206861.wav', 'http://appfile.turingapi.com/watch/voice/201902/5670_4742_1549009468119.wav'],
        question: ['450÷9=50', '800÷10=80', '810÷90=9'],
        width: 0,
        transition: 0,
        tip: 'xxx练习了一位数加一位数，答对了3道题。',
        id: 5,
        skillDetail: [
          {
            title: '1.智能练习模式',
            con: '孩子口答，达到规定的正确率后，进入计时挑战模式',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E7%AE%97%E6%95%B0/%E5%9B%BE%E4%B8%80.png'
          },
          {
            title: '2.计时挑战模式',
            con: '用户在规定时间内，答对8道题即可顺利过关',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E7%AE%97%E6%95%B0/%E5%9B%BE%E4%BA%8C%E4%BA%8C.png'
          },
          {
            title: '3.海量习题，反复强化',
            con: '每个学期至少500道题，让孩子学无止境',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E7%AE%97%E6%95%B0/%E5%9B%BE%E4%B8%89.png'
          },
          {
            type: 'end',
            title: '4.家长查看学习成就',
            con: '宝宝练习了三位数的简单除法，答对了3道题',
            img: ''
          }
        ]
      },
      6: {
        urls: ['http://appfile.turingapi.com/watch/voice/201902/29974_6845_1548990219069.wav', 'http://appfile.turingapi.com/watch/voice/201902/24492_6664_1548990164870.wav', 'http://appfile.turingapi.com/watch/beta/voice/201901/10099_6549_1547443986243.wav'],
        question: ['德高望重', '忐忑不安', '一帆风顺'],
        width: 0,
        transition: 0,
        tip: 'xxx学会了3个成语，点击音频听一听吧！',
        id: 6,
        skillDetail: [
          {
            title: '1.学习环节',
            con: '孩子学习成语的释义，并跟读成语',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E6%88%90%E8%AF%AD/%E5%9B%BE%E4%B8%80.png'
          },
          {
            title: '2.猜成语',
            con: '用户根据文字描述，猜成语',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E6%88%90%E8%AF%AD/%E5%9B%BE%E4%BA%8C.png'
          },
          {
            title: '3.给予奖励',
            con: '根据学习结果，给与奖励',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E5%AD%A6%E6%88%90%E8%AF%AD/%E5%9B%BE%E4%B8%89%E4%B8%89.png'
          },
          {
            type: 'end',
            title: '4.家长查看学习成就',
            con: '宝宝今天学会了3个成语，快来听听吧',
            img: ''
          }
        ]
      },
      7: {
        urls: ['http://appfile.turingapi.com/watch/voice/201902/31097_0_1548972384230.wav', 'http://appfile.turingapi.com/watch/beta/voice/201901/10098_0_1547863182566.wav', 'http://appfile.turingapi.com/watch/beta/voice/201901/10098_0_1547864160302.wav'],
        question: ['Engli_h', 'animal', 'pig'],
        width: 0,
        transition: 0,
        tip: 'xxx拼对了3个单词，点击音频听一听吧！',
        id: 7,
        skillDetail: [
          {
            title: '1.智能出题',
            con: '英语的英文是English，小朋友，下面缺少哪个字母？',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E6%8B%BC%E5%8D%95%E8%AF%8D/%E5%9B%BE%E4%B8%80.png'
          },
          {
            title: '2.用户回答',
            con: '答案是：s',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E6%8B%BC%E5%8D%95%E8%AF%8D/%E5%9B%BE%E4%BA%8C.png'
          },
          {
            title: '3.判断对错',
            con: '系统判断是否正确',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E6%8B%BC%E5%8D%95%E8%AF%8D/%E5%9B%BE%E4%B8%89.png'
          },
          {
            title: '4.给予奖励',
            con: '根据学习结果，给与奖励',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E6%8B%BC%E5%8D%95%E8%AF%8D/%E5%9B%BE%E5%9B%9B.png'
          },
          {
            type: 'end',
            title: '5.家长查看学习成就',
            con: '宝宝今天拼写了3个单词，快来听听吧',
            img: ''
          }
        ]
      },
      8: {
        urls: ['http://appfile.turingapi.com/watch/voice/201904/57_2741_1554049435175.wav', 'http://appfile.turingapi.com/watch/voice/201904/5_17_1554048059982.wav', 'http://appfile.turingapi.com/watch/voice/201904/251459_3667_1554048012164.wav'],
        question: ['柔软', '勤勉', '庞大'],
        width: 0,
        transition: 0,
        tip: 'xxx答对了3个近反义词，点击音频听一听吧！',
        id: 8,
        skillDetail: [
          {
            title: '1.学习环节',
            con: '孩子学习词语的近反义词，并回答问题',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%BF%91%E5%8F%8D%E4%B9%89%E8%AF%8D/1.png'
          },
          {
            title: '2.考核环节',
            con: '用户根据提示，说出答案',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%BF%91%E5%8F%8D%E4%B9%89%E8%AF%8D/2.png'
          },
          {
            title: '3.判断对错',
            con: '根据学习结果，给予奖励',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%BF%91%E5%8F%8D%E4%B9%89%E8%AF%8D/3.png'
          },
          {
            type: 'end',
            title: '4.家长查看学习成就',
            con: '宝宝刚刚学会了3个近/反义词，点击音频听一听吧',
            img: ''
          }
        ]
      },
      9: {
        urls: ['http://appfile.turingapi.com/watch/voice/201812/9314_4947_1543640529008.wav', 'http://appfile.turingapi.com/watch/voice/201812/9314_4948_1543655597751.wav', 'http://appfile.turingapi.com/watch/voice/201812/9314_4606_1543654722664.wav'],
        question: ['She is polite and quiet', 'That’s mary, she is active and friendly', 'elephant'],
        width: 0,
        transition: 0,
        tip: 'xxx新答对了3段英语听力，快来查看吧！',
        id: 9,
        skillDetail: [
          {
            title: '1.纯美式发音，标准纯正',
            con: '专业的美国教师朗读，发音和语速都非常适合小学生',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%8B%B1%E8%AF%AD%E5%90%AC%E5%8A%9B/%E5%9B%BE1.png'
          },
          {
            title: '2.学练结合，学习效果更佳',
            con: '孩子在学、练环节中反复试听对话，做到真正听懂',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%8B%B1%E8%AF%AD%E5%90%AC%E5%8A%9B/%E5%9B%BE2.png'
          },
          {
            title: '3.根据回答情况，给与奖励',
            con: '系统会根据孩子的发音情况判断对错，并给与积分奖励',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/%E8%8B%B1%E8%AF%AD%E5%90%AC%E5%8A%9B/%E5%9B%BE3.png'
          },
          {
            type: 'end',
            title: '4.家长查看学习成就',
            con: '宝宝新答对了3段英语听力，快来查看吧',
            img: ''
          }
        ]
      },
      svip: {
        id: 'svip',
        skillDetail: [
          {
            title: '1.所有技能免费使用',
            con: '所有技能+新上线技能免费使用',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE1.png'
          },
          {
            title: '2.所有智能服务免费使用',
            con: '智能学习助手+新上线智能学习服务免费使用',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE2.png'
          },
          {
            title: '3.寓教于乐的教学模式',
            con: '手表端：IP陪伴+快乐教学引导孩子学习 ',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE3.png'
          },
          {
            title: '4.实时学习计划和进度',
            con: '公众号：实时查询孩子的学习情况和分析报告',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE4.png'
          }
        ]
      },
      updateSvip: {
        id: 'svip',
        skillDetail: [
          {
            title: '1.免费使用小学1-6年级全部技能',
            con: '所有技能+新上线技能都能免费使用',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE1.png'
          },
          {
            title: '2.免费使用智能测评+智能学习服务',
            con: '智能测评+智能学习，确保学习效果',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE2.png'
          },
          {
            title: '3.掌握多维度的学习方式',
            con: '1个知识点多种学习维度，引导孩子深度掌握',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE3.png'
          },
          {
            title: '4.实时查看学习动态和进度',
            con: '公众号实时查询孩子的学习情况和分析报告',
            img: 'https://turing-appstore.oss-cn-beijing.aliyuncs.com/watch/skill/description/svip/%E5%9B%BE4.png'
          }
        ]
      }
    },
    totext: {
      grade: {
        '1': '一',
        '2': '二',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六'
      },
      semester: {
        '0': '无',
        '1': '上',
        '2': '下'
      }
    },
    systemDetail: {},
    hasSystemDetail: false,
    studingDetail: [],
    hasStudingDetail: false,
    expireTime: -1,
    vipType: -1,
    upgradePrice: 0,
    trialRemainSecond: 0,
    adShow: true,
    skillSingleLists: [],
    currentTime: 0,
    faqAnswer: {},
    faqSearch: {
      currentId: 1,
      searchText: ''
    },
    momtherActivityShow: false,
    showIsSaleTag: false,

    jurisdictionId: 2
  },
  mutations: {
    getXTC (state, data) {
      state.isXTC = 1
      sessionStorage.isXTC = 1
    },
    changeLoading (state, data) {
      state.kidLoading = data
    },
    getXTCopenId (state, data) {
      state.xtcOpenId = data
      sessionStorage.xtcOpenId = JSON.stringify(data)
    },
    managePageShowPirvacy (state, data) {
      state.isManagePage = data
    },
    jurisdictionId (state, album) {
      state.jurisdictionId = album
    },
    summerShow (state, album) {
      state.summerShow = album
    },
    momtherActivityShow (state, album) {
      state.momtherActivityShow = album
    },
    showIsSaleTag (state, album) {
      state.showIsSaleTag = album
    },
    faqSearch (state, album) {
      state.faqSearch = album
    },
    faqAnswer (state, album) {
      state.faqAnswer = album
    },
    skillSingleLists (state, album) {
      state.skillSingleLists = album
    },
    currentTime (state, album) {
      state.currentTime = album
    },
    adShow (state, album) {
      state.adShow = album
    },
    trialRemainSecond (state, album) {
      state.trialRemainSecond = album
    },
    upgradePrice (state, album) {
      state.upgradePrice = album
    },
    vipType (state, album) {
      state.vipType = album
    },
    expireTime (state, album) {
      state.expireTime = album
    },
    hasStudingDetail (state, album) {
      state.hasStudingDetail = album
    },
    studingDetail (state, album) {
      state.studingDetail = album
    },
    hasSystemDetail (state, album) {
      state.hasSystemDetail = album
    },
    systemDetail (state, album) {
      state.systemDetail = album
    },
    firstIn (state, album) {
      state.firstIn = album
    },
    isSpring (state, album) {
      state.isSpring = album
    },
    currentPage (state, album) {
      state.currentPage = album
    },
    currentIndex (state, album) {
      state.currentIndex = album
    },
    kidLists (state, album) {
      state.kidLists = album
    },
    currentKid (state, album) {
      state.currentKid = album
    },
    skillStyle (state, album) {
      state.skillStyle = album
    }
  },
  actions: {
    _getSkillSingleByMember ({ commit, state }) {
      if (state.isXTC == 1) { // eslint-disable-line
        getSkillSingleByMemberXtc().then(res => {
          if (res.data.code === 200) {
            let skillLists = {}
            res.data.data.forEach(item => {
              skillLists[item.id] = item
            })
            commit('skillStyle', skillLists)
            sessionStorage.setItem('skillStyle', JSON.stringify(skillLists))
            commit('skillSingleLists', res.data.data)
          }
        })
      } else {
        getSkillSingleByMember().then(res => {
          if (res.data.code === 200) {
            let skillLists = {}
            res.data.data.forEach(item => {
              skillLists[item.id] = item
            })
            commit('skillStyle', skillLists)
            sessionStorage.setItem('skillStyle', JSON.stringify(skillLists))
            commit('skillSingleLists', res.data.data)
          }
        })
      }
    },
    // 获取孩子列表
    _kidLists ({ commit }, callback) {
      return kidLists().then(res => {
        if (res.data.code === 200) {
          commit('changeLoading', false)
          commit('kidLists', res.data.data)
          sessionStorage.setItem('kidLists', JSON.stringify(res.data.data))
          if (router.history.current.name === 'learningAssistant' && res.data.data.length === 0) {
            Toast({
              message: '请先完成设备绑定',
              duration: 1500
            })
            router.push({
              name: 'management'
            })
          }
        }
        res.data.data && res.data.data.length > 0 && callback && callback()

        return res.data.data
      })
    },
    // 获取当前孩子
    _currentKid ({ commit }) {
      currentKid().then(res => {
        if (res.data.data) {
          commit('currentKid', res.data.data.currentKid)
        } else {
          commit('currentKid', null)
        }
      })
    }
  }
})
